// removed by extract-text-webpack-plugin
module.exports = {"buttonWrapper":"src-components-PatientGroups-__messaging-buttons__buttonWrapper--2FVPe","button":"src-components-PatientGroups-__messaging-buttons__button--1acVL","disabledButton":"src-components-PatientGroups-__messaging-buttons__disabledButton--3txd6 src-components-PatientGroups-__messaging-buttons__button--1acVL","label":"src-components-PatientGroups-__messaging-buttons__label--2kPav","textBox":"src-components-PatientGroups-__messaging-buttons__textBox--1xA1O","show":"src-components-PatientGroups-__messaging-buttons__show--X7Zij"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientGroups/messaging-buttons.css
// module id = 1991
// module chunks = 0